// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1bs_L","content":"RecentSearches_content__3QYpx"};